export default __webpack_public_path__ + "static/media/Certificate_5.19b4eb23.jpg";